export default "__VITE_ASSET__B31Mbrjk__"